module.exports = __webpack_public_path__ + "static/img/fire.d9545f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fire.png
// module id = 04Pg
// module chunks = 21